export const getAppName = (): string => {
  return import.meta.env.VITE_APP_NAME || "AI Monitor";
};

